import { useQuery } from "@/services/api";

export const useCheckAuth = () => {
  const { data: checkAuth, isError } = useQuery<any>("/check-auth", {
    queryKey: ["check-auth"],
    cacheTime: 30 * 60 * 1000,
    staleTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return {
    checkAuth,
    isError,
  };
};
